import Swiper, { Navigation, Scrollbar, Zoom, Mousewheel } from 'swiper';

const extractInfoFromAlt = (alt) => {
  const val1 = /Model is wearing size: [\w- "/]+/.exec(alt);
  if (val1) return val1[0];
  return '';
};

const heroProductGallery = (isInline) => ({
  currentSlide: 0,
  swiper: null,
  swiperThumbnails: null,
  swiperEl: null,
  swiperThumbnailsEl: null,

  init() {
    this.$nextTick(() => {
      this.initializeThumbnails();
      this.initializeGallery();
    });

    const variantSelectChangeHandler = ({ detail: { skus: variantSkus } }) => {
      this.activeVariantImage(variantSkus);
    };

    this.boundVariantSelectChangeHandler =
      variantSelectChangeHandler.bind(this);

    window.addEventListener(
      'product-variant-selection-change',
      this.boundVariantSelectChangeHandler
    );
  },

  destroy() {
    window.removeEventListener(
      'product-variant-selection-change',
      this.boundVariantSelectChangeHandler
    );
  },

  activeVariantImage(variantSkus) {
    const foundIdx = this.medias?.findIndex((media) =>
      variantSkus.some((variantSku) => media.variantSkus?.includes(variantSku))
    );

    if (foundIdx > -1) {
      this.setCurrentSlide(foundIdx);
    }
    else {
      if (document.querySelector('.hero-product-gallery--inline .swiper-slide-active video')) {
        document.querySelector('.hero-product-gallery--inline .swiper-slide-active video').play();
      }
      if (document.querySelector('.hero-product-gallery--modal .swiper-slide-active video')) {
        document.querySelector('.hero-product-gallery--modal .swiper-slide-active video').play();
      }
    }
  },

  setCurrentSlide(idx) {
    this.currentSlide = idx;
    this.swiper.slideTo(idx);
    this.swiperThumbnails.slideTo(idx);
  },

  get imagesInfo() {
    return this.medias.map((media) => {
      const { altText } = media;
      if (!altText) return '';
      return extractInfoFromAlt(altText);
    });
  },

  initializeThumbnails() {
    const el = this.$root.querySelector('.js-gallery-thumbnails-swiper');
    if (!el) return;

    const specificConfig = isInline
      ? {
          direction: 'vertical',
          spaceBetween: 16,
          breakpoints: {
            1024: {
              direction: 'horizontal',
            },
            1180: {
              direction: 'vertical',
            },
          },
        }
      : {
          centeredSlides: true,
          spaceBetween: 4,
          direction: 'horizontal',
          breakpoints: {
            768: {
              centeredSlides: true,
              spaceBetween: 16,
              direction: 'horizontal',
            },
            1024: {
              centeredSlides: false,
              spaceBetween: 16,
              direction: 'vertical',
            },
          },
        };

    this.swiperThumbnailsEl = el;
    this.swiperThumbnails = new Swiper(el, {
      slidesPerView: 'auto',
      modules: [Mousewheel],
      mousewheel: {
        forceToAxis: true,
      },
      ...specificConfig,
    });
  },

  initializeGallery() {
    const el = this.$root.querySelector('.js-gallery-swiper');
    if (!el) return;
    // return;

    this.swiperEl = el;
    this.swiper = new Swiper(el, {
      modules: [Navigation, Scrollbar, Mousewheel, !isInline && Zoom].filter(
        Boolean
      ),
      zoom: !isInline,
      mousewheel: {
        forceToAxis: true,
      },
      grabCursor: true,
      preloadImages: false,
      on: {
        slideChange: (swiper) => {
          if (document.querySelector('.hero-product-gallery--inline .swiper-slide-active video')) {
            document.querySelector('.hero-product-gallery--inline .swiper-slide-active video').pause();
          }
          if (document.querySelector('.hero-product-gallery--modal .swiper-slide-active video')) {
            document.querySelector('.hero-product-gallery--modal .swiper-slide-active video').pause();
          }

          this.setCurrentSlide(swiper.activeIndex);

          if (document.querySelector('.hero-product-gallery--inline .swiper-slide-active video')) {
            document.querySelector('.hero-product-gallery--inline .swiper-slide-active video').play();
          }
          if (document.querySelector('.hero-product-gallery--modal .swiper-slide-active video')) {
            document.querySelector('.hero-product-gallery--modal .swiper-slide-active video').play();
          }

          if (!isInline) {
            // defined in modal components
            this.currentSlideInfo = `${swiper.activeIndex + 1}/${
              swiper.slides.length
            }`;
          }
        },
      },
      scrollbar: isInline && {
        el: this.swiperEl.querySelector('.swiper-scrollbar'),
      },
      navigation: {
        nextEl: this.swiperEl.querySelector('.swiper-button-next'),
        prevEl: this.swiperEl.querySelector('.swiper-button-prev'),
        disabledClass: 'swiper-button-hidden',
      },
    });
  },

  openModal() {
    this.$dispatch('hero-product-gallery-open-modal-image', this.currentSlide);
    this.$root.parentElement.querySelector('dialog').showModal();
  },

  handleOpenModalImage({ detail: idx }) {
    if (!isInline) {
      this.swiper.slideTo(idx, 0);
    }
  },
});

export default heroProductGallery;
